import React, { useState } from 'react';
import useTranslation from '../../hooks/use-translation';
import './styles.css';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  formControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    maxWidth: 475,
    width: '100%',
  },
  iconStyle: {
    position: 'absolute',
    top: '34%',
    transform: 'translateY(-50%)',
    right: '10px',
    display: 'inline-block',
    color: '#9D9D9D',
    width: '20px',
    height: '20px',
    pointerEvents: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  menuItem: {
    backgroundColor: '#F5F5F5',
    padding: '10px 29px',
    color: '#333333',
    fontSize: '16px',
    fontFamily: 'jioType-Medium'
  },
  selected: {
    '&.Mui-selected': {
      backgroundColor: '#E5E5E5 !important'
    }
  },
  root: {
    "&$selected, &$selected:focus, &$selected:hover": {
      backgroundColor: "#E5E5E5"
    },
    "&.MuiSelect-select.MuiSelect-select": {
      paddingRight: "0 !important"
    },
    "&.MuiListItem-root.Mui-focusVisible": {
      backgroundColor: "#E5E5E5 !important"
    },
    "&.MuiListItem-button:hover": {
      backgroundColor: "#E5E5E5 !important"
    }
  },
  list: {
    "&.MuiList-padding" : {
      padding: "0 !important"
    },
      border: "0.5px solid #333333"
  }
}));

const BootstrapInput = withStyles((theme) => ({
  root:{
    width: "100%",
    paddingRight: "0 !important",
  },
  input: {
    borderRadius: '8px',
    position: 'relative',
    backgroundColor: '#F5F5F5',
    border: '0.5px solid #333333',
    color: '#333333',
    fontSize: 16,
    height: '27px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '25px',
    paddingRight: '0 !important',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    fontFamily: 'jioType-Medium',
    '&:focus': {
      backgroundColor: '#F5F5F5',
      borderRadius: '8px',
      outline: '1px solid black',
    }
  },
}))(InputBase);

const customStyle = {

}

const dateFormat = "DD-MM-YYYY";

const EditVaccinationDetails = ({
  vaccines = [],
  doseNo = '',
  vaccineName = '',
  vaccineDate = '',
  onSubmit = () => { },
  resetButtons,
  reloadData
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [vaccine, setVaccine] = useState({ value: vaccineName, error: '' });
  const [date, setDate] = useState({ value: vaccineDate, error: '' });
  const [apiError, setApiError] = useState(false);

  const validateInputs = () => {
    let areValid = true;
    if (date.value === "" || new Date(date.value).getTime() > new Date().getTime() || !(moment(moment(date.value).format(dateFormat), dateFormat, true).isValid())) {
      var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

      if (isSafari)
        setDate({
          ...date,
          error: "Please enter a valid date in YYYY-MM-DD"
        })

      else
        setDate({
          ...date,
          error: "Please enter a valid date"
        })

      areValid=false;
    }
    return areValid;
  }

  const handleSubmit = async () => {
    if (!validateInputs()) return;
    const [success, message] = await onSubmit([{
      name: vaccine.value,
      date_of_vaccination: date.value,
      dose: doseNo
    }]);
    if(success){
      setTimeout(()=>{
        reloadData();
        resetButtons();
      },500)
    } else {
      setDate({...date, error: message});
      setApiError(true);
    }
  }

  return (
    <div style={customStyle} className='editcontainer'>
      <h4 className='editTitle'>{t('EDIT_VACCINATION_DETAILS')}</h4>
      <label className='label'>{t('DOSE_LBL')}</label>
      <input className='textInput' readOnly type='text' value={doseNo} />
      <label className='label'>{t('VACCINE_NAME')}</label>
      <Select
        IconComponent={() => <KeyboardArrowDownIcon className={classes.iconStyle} />}
        displayEmpty
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          getContentAnchorEl: null,
          transitionDuration: 0,
          classes:{list: classes.list}
        }}
        renderValue={(value) => {
          if (!value) return t("SELECT");
          return value;
        }}
        value={vaccine.value}
        onChange={(e) => setVaccine({ value: e.target.value, error: '' })}
        input={<BootstrapInput />}
        id="vaccine_select"
      >
        {vaccines.filter((item) => item.name.toLowerCase() != vaccine.value.toLowerCase()).map((item, index) => (
          <MenuItem key={index} classes={{ selected: classes.selected, root: classes.root }} className={classes.menuItem} value={item.name}>{item.name}</MenuItem>
        ))}
      </Select>
      <label className='label'>{t('DATE_LBL')}</label>
      <input max={moment().utcOffset("+05:30").format("YYYY-MM-DD")} className={`textInput mb0 edit-vaccine-date-style ${date.error.length > 0 && !apiError ? 'colorRed':''}`} type='date' placeholder='yyyy-mm-dd' value={date.value} onChange={(e) => {setDate({ value: e.target.value, error: '' }); setApiError(false)}} />
      <div className={`errorMessage ${date.error.length > 0 ? '' : 'mb25'}`}>{date.error}</div>
      <div className='buttonContainer'>
        <button className='button cancelButton' type='button' onClick={resetButtons}>{t('CANCEL')}</button>
        <button className='button submitButton' type='button' onClick={handleSubmit}>{t('SUBMIT')}</button>
      </div>
    </div>
  )
}

export default EditVaccinationDetails;